class GraphicList {
	constructor(container) {
		this._container = ge(container);
		this._graphics = [];
		this._active = null;

		this._selection = new SelectionMgr();
		this._tags = new TagList(TAG.GRAPHICS);
		this._sharing = new Sharing('graphics');
		
		this.emptyState = null;

		this.orderBy = ge('order-by');
		this.searchText = ge('search-text');
		this.filters = new FilterList();
		this.filters.addGroup('Source', 'source', new Sources('graphics'));
		this.filters.addGroup('Tags', 'tag', this._tags);

		onEv(this.orderBy, 'change', this.getList.bind(this));
		onEv(this.searchText, 'keyup paste', this.getList.bind(this));
		onEv(document, 'primaryDataInvalid filterSelected', this.getList.bind(this));
		this.getList();
	}

	getList() {
		API.get(`graphics?order=${this.orderBy.value}` +
			(this.searchText.value !== '' ? '&search=' + encodeURI(this.searchText.value) : '' ) +
			this.filters.toString)
		.then(json => {
			this._container.innerHTML = '';
			if (json.length == 0) {
				this._container.appendChild(this.emptyState = div('no-content', [
				htm('h2', null, _("We can help with this empty space!")),
					img(null, '/images/space/ufo.png'),
					p(null, [
						// btn('btn', img(null, '/images/space/video-btn.png'), {
						// 	'click': () => pageFlow.fromStart(2)
						// }),
						btn('btn', img(null, '/images/space/guide-btn.png'), {
							'click': () => pageFlow.fromStart(10)
						})
					])
				]));
			}
			json.forEach(data => {
				let graphic = Graphic.fromArray(data, this);
				this._container.appendChild(graphic.elem);
			});
			document.dispatchEvent(new Event('primaryDataLoaded'));
		});
	}

	tagSelection(btn) {
		this._tags.mapSelection(this._selection.ids, btn);
	} 

	shareSelection(btn) {
		this._sharing.mapSelection(this._selection.ids, btn);
	}

	deleteSelection() {
		Dialog.Confirm(
			_("Delete all selected graphics, this CANNOT be undone!"),
			_("DELETE SELECTION"),
			() => {
				API.delete('graphics/batch', {
					ids: this._selection.ids
				})
				.then(_ => {
					this._selection.clear();
					document.dispatchEvent(new Event('primaryDataInvalid'));
				});
			}, null, WARNING_DELETE_GRAPHIC_MULTI
		);
	}
}